
window.addEventListener('DOMContentLoaded', (e) => {
  
  /* group action product accordions */
  (() => {
    
    const accordionWrap = document.querySelector('.product-accordion-wrap');
    
    const observer = new MutationObserver(function(mutationsList, e) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if(mutation.target.hasAttribute('open')) {
            const parent = mutation.target.closest('.product__accordion');
            const siblings = Array.from(parent.parentNode.childNodes).filter(node => {
              return node.nodeType === Node.ELEMENT_NODE && node !== parent;
            });
            siblings.forEach(sibling => {
              sibling.querySelector('details')?.removeAttribute('open');
            })
          }
        }
      }
    });
    
    accordionWrap?.querySelectorAll('.product__accordion').forEach((accordion) => {
        const details = accordion.querySelector('details');
        //console.log('details', details);
        observer.observe(details, { attributes: true });
    })
    
    
  })()
  
  


  // takes care of sticky payment button on mobile
  // Get the target element by its ID
  const stickyPaymentButtonWrap = document.querySelector('.product-form__quantity')?.nextElementSibling;
  function slideDown(parentWrap) {
    const elementToTransition = parentWrap.children[0];
    if(!elementToTransition) {
      return;
    }
    elementToTransition.style.animation = 'slide-down 0.2s ease-out';
    setTimeout(() => {
      elementToTransition.style.animation = '';
      parentWrap.classList.remove('sticky');
    }, 300);
  }
  function isElementAboveViewport(element) {
    const boundingClientRect = element.getBoundingClientRect();
    return boundingClientRect.top < 0;
  }
  if(stickyPaymentButtonWrap) {
    // Add scroll event listener
    window.addEventListener('scroll', () => {
      if (!stickyPaymentButtonWrap.classList.contains('sticky') && isElementAboveViewport(stickyPaymentButtonWrap)) {
        stickyPaymentButtonWrap.classList.add('sticky');
      }
    });
    // Set up an intersection observer to watch the target element
    const observer = new IntersectionObserver(entries => {
      // Loop through the observer entries
      entries.forEach(entry => {
        // If the target element is intersecting with the root element
        if (entry.isIntersecting) {
          // Remove the 'sticky' class from the target element
          // stickyPaymentButtonWrap.classList.remove('sticky');
          slideDown(stickyPaymentButtonWrap)
        } else {
          // Check if the target element is above the viewport
          const isAboveViewport = entry.boundingClientRect.top < 0;
          if (isAboveViewport) {
            // If it is, add the 'sticky' class to the target element
            stickyPaymentButtonWrap.classList.add('sticky');
          } else {
            // Otherwise, remove the 'sticky' class from the target element
            // stickyPaymentButtonWrap.classList.remove('sticky');
            slideDown(stickyPaymentButtonWrap)
          }
        }
      });
    });
    
    // Start observing the target element
    observer.observe(stickyPaymentButtonWrap);
  }
  try {
    const subtexts = JSON.parse(document.querySelector('#product-options-subtexts').innerText);
    
    document.querySelectorAll('variant-radios').forEach( variant => {
        
        variant.querySelectorAll('fieldset').forEach( fieldset => {
            
            const legend = fieldset.querySelector('legend');
            
            const extraTexts = subtexts[legend.innerText];
            if(!extraTexts) {
              return;
            }
            
            fieldset.querySelectorAll('input').forEach( input => {
                const label = fieldset.querySelector('[for="'+input.id+'"]');
              
                const word = label.querySelector('.first-word');
                const extraText = extraTexts[word.innerText];
              
                if(extraText) {
                    if(extraText.text) {
                      const extraTextElement = document.createElement('span');
                      extraTextElement.classList.add('rest-of-string');
                      extraTextElement.innerText = extraText.text;
                      label.insertBefore(extraTextElement, word.nextSibling);
                    }
                    if(extraText.badge) {
                      const bageElement = document.createElement('span');
                      bageElement.classList.add('extra-badge');
                      bageElement.innerText = extraText.badge;
                      label.insertBefore(bageElement, word);
                    }
                }
            })
        })
    })
  } catch (e) {
  }

  const updateLegends = () => {
    // for appending selected option in front of the legend name in radio variants on load
    document.querySelectorAll('variant-radios fieldset').forEach( fieldset => {
      const legend = fieldset.querySelector('legend');
      let span = legend.querySelector('span')
      if(!span) {
          
          span = document.createElement('span')
          legend.append(span);
      }
      span.innerText= ' '+fieldset.querySelector('input:checked')?.value
      
    });
  }

  updateLegends();

  // const setGalleryThumbs = () => {
  //   document.querySelectorAll('li.product__media-item.grid__item.slider__slide:not(.product__media-item--variant)').forEach( li => {
  //       const fertilizerType = document.querySelector('variant-radios fieldset.product-form__input input:checked').value;
        
  //       if(li.querySelector('.product__media > img')?.getAttribute('alt')?.startsWith(fertilizerType)) {
  //           li.style.display = null
  //       } else {
  //           li.style.display = 'none'
  //       }
  //   })
  // }

  const setGalleryThumbs = () => {
    
    const selected = [
      ...document.querySelector('variant-radios fieldset.product-form__input input:checked')?.value ? [document.querySelector('variant-radios fieldset.product-form__input input:checked').value] : [],
      ...document.querySelector('variant-radios fieldset.product-form__input:nth-child(2) input:checked')?.value ? [document.querySelector('variant-radios fieldset.product-form__input:nth-child(2) input:checked').value] : []
    ]

    document.querySelectorAll('.product__media-wrapper li.slider__slide:not(.product__media-item--variant)').forEach( li => {
        const imgAlt = li.querySelector('img')?.getAttribute('alt');
        if(imgAlt) {
            const tags = imgAlt.split('/').map(val => val.trim().toLowerCase());
            let tagsMatch = true;
            tags.forEach((tag, index) => {
              if(tag !== selected[index]?.toLowerCase()) {
                tagsMatch = false;
              }
            })
            if(tagsMatch) {
              li.style.display = null;
            } else {
              li.style.display = 'none';
            }
        } else {
            li.style.display = null;
        }
    })
  }

  setGalleryThumbs();

  const displayTechSpecs = (techSpecs) => {
    const specIndex = techSpecs.selectedIndex;
      const gid = techSpecs.querySelectorAll('option')[specIndex].value
      
      document.querySelectorAll('.tech-spec-item').forEach(item => {
          if(gid.endsWith(item.dataset.instance)) {
              item.style.display='';
          } else {
              item.style.display='none';
          }
      });

  }
  
  (() => {
    // Check if elements exist on the page before attaching events or modifying them
    const productTitles = document.querySelectorAll('.product__title h1:not(.variant-custom) span.variant-title');
    const techSpecs = document.querySelector('#tech-spec-variant-select');

    // Check if techSpecs exists before attaching an event
    if (techSpecs) {
        techSpecs.addEventListener('change', () => {
            setTimeout(() => {
                displayTechSpecs(techSpecs)
            }, 0)
        });
    }

    let url = new URL(window.location.href);
    let defaultVariantId = url.searchParams.get("variant");
    if (techSpecs) {
        techSpecs.selectedIndex = defaultVariantId ? Array.from(techSpecs.querySelectorAll('option')).indexOf(techSpecs.querySelector(`#id${defaultVariantId}`)) : 0;
        displayTechSpecs(techSpecs);
    }

    // Ensure variant-radios elements exist before iterating over them
    const variantRadios = document.querySelectorAll('variant-radios');
    if (variantRadios.length) {
        variantRadios.forEach(variant => {
            variant.onchange = (e) => {
                if (techSpecs) {
                    techSpecs.selectedIndex = Array.from(techSpecs.querySelectorAll('option')).indexOf(techSpecs.querySelector(`#id${variant.currentVariant.id}`))
                    displayTechSpecs(techSpecs);
                }
                // Ensure productTitles exists before iterating over them
                if (productTitles.length) {
                    productTitles.forEach(productTitle => {
                        productTitle.innerText = e.target.value;
                    });
                }
                updateLegends();
                setGalleryThumbs();
            }
        });
    }
})();


  // (() => {
    // Product page toc, set stuck class
    const el = document.querySelector(".shopify-section.product-toc")
    if(el) {
      const observer = new IntersectionObserver( 
        ([e]) => e.target.classList.toggle("stuck", e.intersectionRatio < 1),
        { threshold: [1] }
      );
      observer.observe(el);
    }
  // })()
  
  

  // price change on variant selction to show new price on the mobile top
  // (() => {
      
      // Get the div element you want to observe
      const divElement = document.querySelector('section:not([id$="mobile-product-head"]) product-info .product__title + div');
      
      // console.log('that', divElement)
      // Create a new MutationObserver instance
  if(divElement) {
      const observer2 = new MutationObserver(function(mutations) {
          // console.log('that', divElement.innerHtML)
          // console.log('update will be set on', document.querySelector('section[id$="mobile-product-head"] product-info .product__title + div'));
          document.querySelector('section[id$="mobile-product-head"] product-info .product__title + div').innerHTML = divElement.innerHTML;
          document.querySelector('button.product-form__submit > .price').innerHTML = divElement.querySelector('.price').innerHTML
      });
      
      // Start observing the div element for changes to its content
      observer2.observe(divElement, { childList: true });
  }
      // console.log('observer set', divElement)
  // })()



  // (() => {
    let variantCustom = [];
    const variantSelector = document.querySelector('variant-radios')
    
    try {
        variantCustom = JSON.parse( document.getElementById('variants-custom-fields').innerText );
    } catch(e) {
    
    }
    
    if(!variantSelector || !variantCustom.length) {
      return;
    }
    const populateVariantCustom = () => {
        const data = variantCustom.find(({variant_id}) => {
            return variant_id === (variantSelector.currentVariant?.id ?? defVarId)
        });
        const contentBlock = document.querySelectorAll('product-info')[1].querySelector('.content_block');
        const titleBlocks = document.querySelectorAll('product-info .product__title');
        document.querySelectorAll('h1.variant-custom').forEach(item => item.remove());
        if(data?.variant_title) {
          titleBlocks.forEach(titleBlock => {
              titleBlock.querySelector('h1.variant-custom')?.remove();
              if(titleBlock.querySelector('h1:not(.variant-custom)')) {
                  titleBlock.querySelector('h1:not(.variant-custom)').style.display='none';
              }
              const customP = document.createElement('h1');
              customP.classList.add('variant-custom');
              customP.innerText = data.variant_title;
              titleBlock.appendChild(customP)
          })
        } else {
          titleBlocks.forEach(titleBlock => {
              titleBlock.querySelector('h1.variant-custom')?.remove();
              if(titleBlock.querySelector('h1:not(.variant-custom)')) {
                titleBlock.querySelector('h1:not(.variant-custom)').style.display=null;
              }
          });
        }

        if(contentBlock) {
            if(data?.variant_description) {
            
                contentBlock.querySelector('p.variant-custom')?.remove();
                if(contentBlock.querySelector('p:not(.variant-custom)')) {
                  contentBlock.querySelector('p:not(.variant-custom)').style.display='none';
                }
                const customP = document.createElement('p');
                customP.classList.add('variant-custom');
                customP.innerText = data.variant_description;
                contentBlock.appendChild(customP)
            } else {
                contentBlock.querySelector('p.variant-custom')?.remove();
                if(contentBlock.querySelector('p:not(.variant-custom)')) {
                  contentBlock.querySelector('p:not(.variant-custom)').style.display=null;
                }
            }

            const listBlockWrapOriginal = document.querySelectorAll('product-info')[1].querySelector('.list-block-wrap:not(.variant-features)');
            
            document.querySelectorAll('product-info')[1].querySelector('.content_block + .list-block-wrap.variant-features')?.remove();
            // console.log(listBlockWrapOriginal);
            const variantFeatures = [
                ...data?.variant_feature_1 ? [data.variant_feature_1] : [],
                ...data?.variant_feature_2 ? [data.variant_feature_2] : [],
                ...data?.variant_feature_3 ? [data.variant_feature_3] : [],
                ...data?.variant_feature_4 ? [data.variant_feature_4] : []
            ];
            
            if(variantFeatures.length) {
              const listBlockWrap = document.createElement('div');
              listBlockWrap.classList.add('list-block-wrap');
              listBlockWrap.classList.add('variant-features');
              listBlockWrap.innerHTML = variantFeatures.map((feature) => {
                const splitted = feature.split(':');
                return "<div class='list_block'>" + (splitted.length === 2 ? '<b>'+splitted[0]+'</b>:' + splitted[1] : splitted[0]) + "</div>";
                
              }).join("\n");
              contentBlock.parentNode.insertBefore(listBlockWrap, contentBlock.nextSibling);
              listBlockWrapOriginal.style.display='none';
            } else {
              // console.log(listBlockWrapOriginal, 'set display to null');
              listBlockWrapOriginal.style.display = null;
            }
            
            

            
        }
            
    }
    
    variantSelector.addEventListener('change', populateVariantCustom);
    
    populateVariantCustom();
  // })()
})

